<template>
  <div class="head-container">
    <div class="logo">
      <img src="~@/assets/images/logo.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    resetData() {
      this.$confirm({
        title: "提示",
        content: "是否确认清空对话记录？",
        okText: "是",
        cancelText: "否",
        onOk() {
          sessionStorage.removeItem(
            `${process.env.VUE_APP_NAME}:conversation_id`
          );
          location.reload();
        },
        onCancel() {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";

.head-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8% 0 5% 0;
  box-sizing: border-box;
  background: rgba(7, 31, 64, 1);
  border-bottom: 1px solid #446a84;
  .logo-text {
    width: 100%;
    font-size: 20px;
    color: @qa-header-text-color;
    font-weight: 600;
  }
  .ant-divider {
    height: 2rem;
  }
  .logo {
    width: 100%;
    text-align: center;
    img {
      width: 50%;
      object-fit: contain;
    }
  }
}
</style>
